import TaskTypeService from 'src/services/taskTypeService';

const state = {
  taskTypes: undefined
};

const getters = {
  getTaskTypes: (state) => state.taskTypes,
};
const actions = {
  async fetchTaskTypes({ commit, state, rootGetters }) {
    // Only load the data once
    if (state.taskTypes == undefined) {
      return TaskTypeService.fetchAll()
      .then(r => {
        commit('setTaskTypes', r.data.sort(
          (a, b) => a.display_order < b.display_order ? -1 : 0)
        );
      });
    }
  },
  unloadTaskTypes({ commit }) {
    commit('setTaskTypes', undefined);
  }
};
const mutations = {
  setTaskTypes(state, types) {
    state.taskTypes = types;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
